import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, isRef as _isRef } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  style: {
    "width": "100%"
  }
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangchuan"
}, null, -1);

const _hoisted_4 = {
  class: "mg-l--5"
};
import FormTable from '@/components/FormTable/index.vue';
import ManuallyUpload from '@/components/Upload/ManuallyUpload.vue';
import { validateImageUrl } from '@/utils/validate';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: Array,
      default: ['png', 'jpg']
    },
    accept: {
      type: String,
      default: ".png,.jpg"
    },
    limit: {
      type: Number,
      default: 1
    },
    col: {
      type: Array,
      default: ['20%', '35%', '20%', '35%']
    },
    urlStr: {
      type: String,
      default: ""
    }
  },
  emits: ['update:modelValue', 'on-comfirm'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const FormRef = ref(null);

    const handleCheckChange = val => {
      formConfig.formData.type = val;
      formConfig.formData.url = props.urlStr ? props.urlStr : '';
      formConfig.formData.file = [];
      formConfig.formData.base64Image = '';
    };

    const fileChange = file => {
      // 显示图标
      let reader = new FileReader(); //转base64

      reader.onload = function (e) {
        const res = e.target.result; //将图片路径赋值给src

        formConfig.formData.file = [];
        formConfig.formData.file = file;
        formConfig.formData.base64Image = res;
        FormRef.value.mForm.validateField('file');
      };

      reader.readAsDataURL(file.raw);
    };

    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '上传图片',
        destroyOnClose: true
      },
      confirm: done => {
        FormRef.value.mForm.validate(valid => {
          if (valid) {
            // console.log(formConfig.formData);
            emit('on-comfirm', formConfig.formData, () => closeDialog(done));
          } else {
            done();
          }
        });
      },
      cancel: () => {
        emit('update:modelValue', false);
      }
    });

    const closeDialog = done => {
      emit('update:modelValue', false);
      done();
    };

    const validFile = async (rule, value, callback) => {
      if (!value.size) return callback(new Error(t('请上传文件!')));
      if (value.size > 512000) return callback(new Error(t('图片大小建议在500kb以内。')));
      callback();
    };

    const formConfig = reactive({
      formList: [[{
        label: '添加方式',
        prop: 'type',
        itemSlot: true,
        widgetType: 'input',
        controller: (value, data, config) => {
          return true;
        },
        colspan: 3
      }], [{
        label: '图片URL',
        prop: 'url',
        // widgetType: 'input',
        widgetType: 'tooltipInput',
        required: true,
        controller: (value, data, config) => {
          return data.type === 1 ? false : true;
        },
        colspan: 3
      }], [{
        label: '文件',
        prop: 'file',
        itemSlot: true,
        required: true,
        widgetType: 'text',
        controller: (value, data, config) => {
          return data.type === 1 ? true : false;
        },
        colspan: 3
      }]],
      formData: {
        type: 1,
        url: props.urlStr ? props.urlStr : '',
        file: [],
        base64Image: ''
      },
      rules: {
        url: [{
          required: true,
          validator: validateImageUrl,
          trigger: 'blur'
        }, {
          required: true,
          max: 512,
          message: t('限制字符数量', {
            num: '512'
          }),
          trigger: 'blur'
        }],
        file: [{
          required: true,
          validator: validFile,
          trigger: 'change'
        }]
      }
    });

    const handelRemove = file => {
      formConfig.formData.file = [];
      FormRef.value.mForm.validateField('file');
    };

    watch(() => props.modelValue, val => {
      if (val) {
        formConfig.formData = {
          type: 1,
          url: props.urlStr ? props.urlStr : '',
          file: [],
          base64Image: ''
        };
      }

      if (FormRef.value) {
        FormRef.value.mForm.clearValidate();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_button = _resolveComponent("el-button");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_MDialog = _resolveComponent("MDialog");

      return _openBlock(), _createBlock(_component_MDialog, {
        autoLoading: "",
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm,
        onOnClose: dialogConfig.cancel,
        nativeConfig: {
          closeOnClickModal: false
        }
      }, {
        default: _withCtx(() => [_createVNode(FormTable, {
          ref_key: "FormRef",
          ref: FormRef,
          formRules: formConfig.rules,
          formData: formConfig.formData,
          col: __props.col
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": formConfig.formData
            }, {
              itemSlot: _withCtx(scope => [scope.prop === 'type' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
                "model-value": formConfig.formData.type === 1,
                onChange: _cache[0] || (_cache[0] = $event => handleCheckChange(1)),
                label: _ctx.$t('上传图片'),
                size: "large"
              }, null, 8, ["model-value", "label"]), _createVNode(_component_el_checkbox, {
                "model-value": formConfig.formData.type === 0,
                onChange: _cache[1] || (_cache[1] = $event => handleCheckChange(0)),
                label: _ctx.$t('输入URL'),
                size: "large"
              }, null, 8, ["model-value", "label"])])])) : _createCommentVNode("", true), scope.prop === 'file' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [__props.modelValue ? (_openBlock(), _createBlock(ManuallyUpload, {
                key: 0,
                style: {
                  "width": "100%"
                },
                limit: __props.limit,
                cover: "",
                fileType: __props.fileType,
                accept: __props.accept,
                onHandleChange: fileChange,
                onHandelRemove: handelRemove
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('点击上传')), 1)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["limit", "fileType", "accept"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["formRules", "formData", "col"]), _renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm", "onOnClose"]);
    };
  }

});